<template>
  <el-dialog
    custom-class="effect-order-dialog"
    title="请选择订单"
    append-to-body
    center
    :visible.sync="visible"
    width="900px"
    @close="hideDialog"
    :destroy-on-close="true"
  >
    <div>
      <el-form
        ref="searchForm"
        label-position="right"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        style="margin-bottom: 10px"
        label-width="80px"
      >
        <el-form-item label="推送日期" prop="pushDate">
          <el-date-picker
            v-model="searchForm.pushDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px;"
            :pickerOptions="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="要求发货日" prop="sendDate">
          <el-date-picker
            v-model="searchForm.sendDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px;"
            :pickerOptions="pickerOptions"
          />
        </el-form-item>

        <el-form-item label="R0订单号" prop="main_number">
          <el-input v-model="searchForm.main_number" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            style="background:#fff;color:#FF6224;border-color:#ccc;color:#666;"
            @click="resetForm"
            >重置
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="onSearch"
            style="background:#FF6224;color:#fff;border-color:#FF6224;"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div style="padding-top: 8px;">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%; text-align: center"
          size="mini"
          @select="handleSelection"
          @select-all="handleSelectAll"
          :row-key="row => row.id"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
            :selectable="checkSelectable"
          />
          <el-table-column prop="serial_number" label="编号" width="100" />
          <el-table-column prop="main_number" label="订单编号" />
          <el-table-column prop="created_at" label="推送日期" />
          <el-table-column prop="out_ware_day" label="要求发货日" />
          <el-table-column prop="total_amount" label="订单总金额"
            ><template slot-scope="scope">
              <div>￥{{ scope.row.total_amount }}</div>
            </template></el-table-column
          >
          <el-table-column prop="mo_status_str" label="订单状态" />
        </el-table>
      </div>
      <el-pagination
        style="text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.page_size"
        layout="total,sizes, prev, pager, next,jumper"
        :total="queryInfo.total"
      >
      </el-pagination>
    </div>
    <div class="flex-row-center-center" style="margin-top: 30px;">
      <el-button
        @click="hideDialog"
        size="medium"
        style="background:#fff;color:#FF6224;border-color:#ccc;color:#666;margin-right: 16px;"
        >取消
      </el-button>
      <el-button type="primary" size="medium" @click="onSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getOrderList } from "@/models/orderReportModel";
import moment from "moment";
export default {
  props: ["selectAllIds"],
  data() {
    return {
      tableData: [], // 表格数据
      selectionRows: [],
      queryInfo: {
        page: 1,
        page_size: 10,
        current: 1, // 当前页
        total: 0 //总数
      },
      searchForm: {
        pushDate: undefined,
        sendDate: undefined,
        main_number: undefined,
        page: 1,
        page_size: 10,
        is_edit: 0
      },
      visible: false,
      loading: false,
      pickerOptions: {
        disabledDate(current) {
          return (
            current &&
            (current > moment().add(1, "months") ||
              current < moment().subtract(1, "months"))
          );
        }
      }
    };
  },
  methods: {
    showDialog() {
      this.visible = true;
      // 默认查询条件：
      // 推送日期：前一周~当天
      // 要求发货日：前一周~后一周
      var preDate = new Date();
      preDate.setDate(preDate.getDate() - 7);
      let afterDate = new Date();
      afterDate.setDate(afterDate.getDate() + 7);

      this.searchForm.pushDate = [preDate, new Date()];
      this.searchForm.sendDate = [preDate, afterDate];
      this.$nextTick(() => {
        this.getList();
      });
    },

    hideDialog() {
      this.visible = false;
    },
    // 查询btn
    onSearch() {
      this.queryInfo.page = 1;
      this.queryInfo.page_size = 10;
      this.searchForm.page = 1;
      this.searchForm.page_size = 10;
      this.getList({ ...this.searchForm, page: 1, page_size: 10 });
    },
    // 重置btn
    resetForm() {
      this.searchForm = {
        pushDate: undefined,
        sendDate: undefined,
        page: 1,
        page_size: 10,
        is_edit: 0
      };
      this.queryInfo = {
        page: 1,
        page_size: 10,
        current: 1, // 当前页
        total: 0 //总数
      };
      // this.tableData = [];
    },
    // 查询订单
    getList(param) {
      const searchParams = param || this.searchForm;
      const {
        pushDate,
        sendDate,
        page,
        page_size,
        is_edit,
        main_number
      } = searchParams;
      const params = {
        is_edit,
        main_number,
        page: page || this.queryInfo.page || 1,
        page_size: page_size || this.queryInfo.page_size || 10
      };
      if (!pushDate || !sendDate) {
        this.$message({
          message: "请选择推送日期和要求发货日！",
          type: "warning"
        });
        return false;
      }
      if (pushDate && pushDate.length == 2) {
        params.push_start_time = moment(pushDate[0]).format("YYYY-MM-DD");
        params.push_end_time = moment(pushDate[1]).format("YYYY-MM-DD");
      }
      if (sendDate && sendDate.length == 2) {
        params.shipping_start_time = moment(sendDate[0]).format("YYYY-MM-DD");
        params.shipping_end_time = moment(sendDate[1]).format("YYYY-MM-DD");
      }
      getOrderList(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.list || []; // 获取数据
          this.queryInfo.total = res.total;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 改变pagesize
    handleSizeChange(value) {
      this.queryInfo.page_size = value;
      this.searchForm.page_size = value;
      const params = { ...this.searchForm, page_size: value };
      this.getList(params);
    },
    // 改变page
    handleCurrentChange(value) {
      this.queryInfo.page = value;
      this.searchForm.page = value;
      const params = { ...this.searchForm, page: value };
      this.getList(params);
    },
    handleSelection(val) {
      this.selectionRows = val;
    },
    handleSelectAll(val) {
      this.selectionRows = val;
    },
    // 判断已选择的订单（不可选中）
    checkSelectable(row) {
      const ids = this.selectAllIds
        ? this.selectAllIds.split(",").map(Number)
        : [];
      const res = !(ids.indexOf(row.id) >= 0);
      return res;
    },
    // 提交
    onSubmit() {
      if (this.selectionRows.length == 0) {
        this.$message({
          message: "请选择要添加的订单！",
          type: "warning"
        });
        return false;
      }
      const ids = this.selectionRows.map(item => {
        return item.id;
      });
      // console.log("ids:", ids);
      this.$emit("setOrderIds", ids);
      this.hideDialog();
    }
  }
};
</script>
<style lang="scss">
.effect-order-dialog {
  .el-pagination__editor {
    width: 60px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderReport/reportCenter/components/effectDialog.vue